import { render } from "./HeadingComponent.vue?vue&type=template&id=08067c52"
const script = {}

import "./HeadingComponent.vue?vue&type=style&index=0&id=08067c52&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__